import React from 'react';
import { Link } from 'react-router-dom';
import { getSeoRoute } from '@/lib/routeHelper';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 pt-12 pb-6">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold text-white mb-4">splusd solutions</h3>
            <p className="mb-4">
            - analysiere Potenziale - <br />
            - schaffe effiziente Prozesse - <br />
            - entwickle digitale Produkte - <br />
            - verändere damit deine Zukunft -
            </p>
          </div>
          
          {/*<div>
            <h4 className="text-lg font-bold text-white mb-4">Leistungen</h4>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white">Prozessautomatisierung</a></li>
              <li><a href="#" className="hover:text-white">Softwareentwicklung</a></li>
              <li><a href="#" className="hover:text-white">Digitale Beratung</a></li>
              <li><a href="#" className="hover:text-white">E-Commerce Lösungen</a></li>
            </ul>
          </div>*/}
          
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Kontakt</h4>
            <address className="not-italic">
              <p className="mb-2">Büros in:</p>
              <p className="mb-2">44369 Dortmund</p>
              <p className="mb-2">51645 Gummersbach</p>
              <p className="mb-2">info@splusd-solutions.com</p>
              <p className="mb-2">02265 9999 775</p>
            </address>
          </div>
          
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Links</h4>
            <ul className="space-y-2">
              <li><Link to={getSeoRoute("/datenschutz")} className="hover:text-white">Datenschutz</Link></li>
              <li><Link to={getSeoRoute("/impressum")} className="hover:text-white">Impressum</Link></li>
              <li><Link to={getSeoRoute("/agb")} className="hover:text-white">AGB</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>&copy; {new Date().getFullYear()} splusd solutions. Alle Rechte vorbehalten.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
